// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "item-3fU5D";
export { _1 as "__esModule", _2 as "item" }
export default { "__esModule": _1, "item": _2 }
